module.exports = __webpack_public_path__ + "media/images/lp/1/donation2-title-sp-77b860f5ba3fc50705565c6c3350fafb.png";